import { render, staticRenderFns } from "./AppBuilderArticle.vue?vue&type=template&id=4be28a1a&"
import script from "./AppBuilderArticle.vue?vue&type=script&lang=js&"
export * from "./AppBuilderArticle.vue?vue&type=script&lang=js&"
import style0 from "./AppBuilderArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports